<template>
  <div class="sidebar" :data-color="backgroundColor">

    <div class="logo">
      <div class="logo-image"  >
        <img style="height: 44px;margin-top: 4px;margin-left:18px;" :src="logo">
      </div>
      <div class="navbar-minimize">
        <!--<button id="minimizeSidebar" class="btn btn-simple btn-icon btn-neutral btn-round" @click="minimizeSidebar">-->
        <button id="minimizeSidebar" class="btn btn-simple btn-icon btn-neutral btn-round" @click="$sidebar.toggleMinimize">
          <i class="now-ui-icons text_align-center visible-on-sidebar-regular"></i>
          <i class="now-ui-icons design_bullet-list-67 visible-on-sidebar-mini"></i>
        </button>
      </div>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea" >
      <slot ></slot>
      <ul class="nav">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link">

            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink">
            </sidebar-item>
          </sidebar-item>
        </slot>

      </ul>
    </div>
  </div>
</template>
<script>
  // @click="$sidebar.toggleMaximize"
  export default {
    name: 'sidebar',
    props: {
      title: {
        type: String,
        default: 'OneClose'
      },
      backgroundColor: {
        type: String,
        default: 'blue',
        validator: (value) => {
          let acceptedValues = ['', 'blue', 'azure', 'green', 'orange', 'red', 'purple', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      logo: {
        type: String,
        default: require('@/assets/img/oneclose-door.png')
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      },
      autoClose: {
        type: Boolean,
        default: true
      }
    },
    provide () {
      return {
        autoClose: this.autoClose
      }
    },
    methods: {
      minimizeSidebar () {
        if (this.$sidebar) {
          this.$sidebar.toggleMinimize()
        }
      }
    },
    beforeDestroy () {
      /*if (this.$sidebar && this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }*/
    },
    mounted () {
      // temporary hack to start with full width sidebar
      // TODO: add to Vuex a sidebar state and manage saved state of user preference
      this.$sidebar.toggleMinimize()
    }
  }

</script>
<style>
  @media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu{
      display: none;
    }
  }
</style>
